// Catálogos de la pantalla Crédito › Documentos (/Credito/Documentos).
// Fecha de creación: 2026-09-16 — Autor: IA (Claude)
// Los valores (value) son los que espera/regresa el endpoint "Documentos".

export const FINANCIERAS_DOCUMENTOS = [
  { value: 0, label: "MHUSA" },
  { value: 1, label: "JDF" },
];

export const TIPOS_PERSONA_DOCUMENTO = [
  { value: "A", label: "AMBAS" },
  { value: "F", label: "FISICA" },
  { value: "M", label: "MORAL" },
];

export const LINEAS_CREDITO_DOCUMENTO = [
  { value: "T", label: "TODAS" },
  { value: "O", label: "OPERACION" },
  { value: "R", label: "REVOLVENTE" },
];

// Devuelve la etiqueta de un catálogo o "" si el valor no existe.
export const etiquetaCatalogo = (catalogo, valor) =>
  catalogo.find((item) => String(item.value) === String(valor))?.label ?? "";
